import { __read } from '../node_modules/tslib/tslib.es6.esm.js';
import * as React from 'react';

var useCloseEvents = function (ref) {
    var _a = __read(React.useState(false), 2), isOpen = _a[0], setIsOpen = _a[1];
    var toggleOpen = React.useCallback(function () {
        setIsOpen(function (prevState) { return !prevState; });
    }, []);
    var handleOpen = React.useCallback(function () {
        setIsOpen(true);
    }, []);
    var handleClose = React.useCallback(function () {
        setIsOpen(false);
    }, []);
    var closeIfEscWasPressed = React.useCallback(function (event) {
        if (event.key === 'Escape') {
            handleClose();
        }
    }, []);
    var closeIfClickOutside = React.useCallback(function (event) {
        if (!(ref === null || ref === void 0 ? void 0 : ref.current))
            return;
        /**
         * A way to verify if user is clicking inside ref
         */
        var path = event.path || (event.composedPath && event.composedPath());
        var isChildrenOfRef = path.includes(ref.current);
        var isInside = event.target === ref.current;
        if (!isInside && !isChildrenOfRef)
            handleClose();
    }, [ref, handleClose]);
    React.useEffect(function () {
        if (!isOpen || !(ref === null || ref === void 0 ? void 0 : ref.current))
            return;
        global.window.addEventListener('keydown', closeIfEscWasPressed);
        global.window.addEventListener('click', closeIfClickOutside);
        return function () {
            global.window.removeEventListener('keydown', closeIfEscWasPressed);
            global.window.removeEventListener('click', closeIfClickOutside);
        };
    }, [ref, closeIfEscWasPressed, closeIfClickOutside, isOpen]);
    return {
        handleClose: handleClose,
        handleOpen: handleOpen,
        isOpen: isOpen,
        toggleOpen: toggleOpen,
    };
};

export { useCloseEvents as default };
//# sourceMappingURL=useCloseEvents.esm.js.map
